import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";

export default function WorkoutPicker({ item, index, addWorkout }) {
  //   useEffect(() => {}, []);

  const [isSel, setIsSel] = useState(false);

  return (
    <a
      style={{ cursor: "pointer" }}
      onClick={() => {
        addWorkout(!isSel, item);
        setIsSel(!isSel);
      }}
      key={"workoutpicker" + index}
    >
      <div key={index} className="list-container">
        <div
          style={{ backgroundColor: isSel ? "#ecf5ff" : "#fff" }}
          className="list-item"
        >
          <p
            style={{
              padding: 2,
              border: "1px solid hsl(210, 14%, 83%)",
              marginRight: 15,
              marginLeft: 10,
              backgroundColor: "#fff",
            }}
          >
            <FontAwesomeIcon
              style={{ color: isSel ? "#21252b" : "transparent" }}
              icon={icon({ name: "check", style: "solid" })}
            />
          </p>
          <p style={{ color: "#000" }}>{item?.name_de}</p>
        </div>
      </div>
    </a>
  );
}
